import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Register() {
  const { register, error } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(email, password, name);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="w-full max-w-sm space-y-8" data-testid="register-container">
        <div>
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_infra-manager-15/artifacts/9lvbt023_Logo%20only%20kayser%20Kopie.png"
            alt="KAYSER"
            className="h-10 w-auto object-contain"
            data-testid="brand-logo"
          />
        </div>
        <div>
          <h2 className="font-heading text-3xl font-bold tracking-tight">Konto erstellen</h2>
          <p className="text-muted-foreground text-sm mt-1">Starte in wenigen Sekunden.</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="name">Name</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">E-Mail</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Passwort (min. 6 Zeichen)</Label>
            <Input id="password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password" />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="register-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit">
            {loading ? "Erstelle Konto …" : "Konto erstellen"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground">
          Bereits registriert?{" "}
          <Link to="/login" className="text-primary font-medium hover:underline" data-testid="link-login">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
